"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
var _utils = require("../utils");
var _image = _interopRequireDefault(require("../image"));
var _dayjs = _interopRequireDefault(require("dayjs"));
var _use = (0, _utils.use)('step'),
  sfc = _use[0],
  bem = _use[1];
var _default2 = sfc({
  props: {
    title: String,
    time: [String, Number],
    timeFormat: {
      type: Array,
      default: function _default() {
        return ['MM-DD', 'HH:mm'];
      }
    },
    description: String,
    imageActive: String,
    imageDeactive: String
  },
  computed: {
    active: function active() {
      var index = this.$parent.steps.indexOf(this);
      var _this$$parent = this.$parent,
        active = _this$$parent.active,
        direction = _this$$parent.direction;
      return direction === 'vertical' ? index === this.$parent.steps.length - 1 : index <= active;
    }
  },
  beforeCreate: function beforeCreate() {
    this.$parent.steps.push(this);
  },
  methods: {
    renderHorizontal: function renderHorizontal() {
      var h = this.$createElement;
      var _this$$parent2 = this.$parent,
        direction = _this$$parent2.direction,
        iconSize = _this$$parent2.iconSize,
        activeTextColor = _this$$parent2.activeTextColor,
        deactiveTextColor = _this$$parent2.deactiveTextColor;
      var active = this.active,
        title = this.title,
        imageActive = this.imageActive,
        imageDeactive = this.imageDeactive;
      return h("div", {
        "class": bem('', direction)
      }, [h(_image.default, {
        "class": bem('icon'),
        "attrs": {
          "width": iconSize,
          "height": iconSize,
          "fit": "cover",
          "src": active ? imageActive : imageDeactive
        }
      }), h("div", {
        "class": bem('title'),
        "style": {
          color: active ? activeTextColor : deactiveTextColor
        }
      }, [title])]);
    },
    renderVertical: function renderVertical() {
      var h = this.$createElement;
      var _this$$parent3 = this.$parent,
        direction = _this$$parent3.direction,
        dayWidth = _this$$parent3.dayWidth;
      var active = this.active,
        title = this.title,
        description = this.description,
        timeFormat = this.timeFormat;
      var day = (0, _dayjs.default)(this.time || 0);
      var date = timeFormat[0] ? day.format(timeFormat[0]) : '';
      var time = timeFormat[1] ? day.format(timeFormat[1]) : '';
      return h("div", {
        "class": bem('', direction)
      }, [h("div", {
        "ref": "day",
        "class": bem('day', {
          'active': active
        }),
        "style": {
          minWidth: dayWidth + "px"
        }
      }, [h("div", {
        "class": bem('date')
      }, [date]), h("div", {
        "class": bem('time')
      }, [time])]), h("div", {
        "class": bem('content')
      }, [h("div", {
        "class": bem('title', {
          'active': active
        })
      }, [this.$slots.title ? this.slots('title') : title]), h("div", {
        "class": bem('description', {
          'active': active
        })
      }, [this.$slots.description ? this.slots('description') : description])])]);
    }
  },
  render: function render(h) {
    var direction = this.$parent.direction;
    return direction === 'vertical' ? this.renderVertical() : this.renderHorizontal();
  }
});
exports.default = _default2;